import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IDeleteActivityItemsProps {
  activityItemId: string;
  isVerified?: boolean;
}

const deleteActivityItemsService = async ({
  activityItemId,
  isVerified,
}: IDeleteActivityItemsProps): Promise<void> => {
  await wbsBookingsApi.delete(`/activities/items/${activityItemId}`, {
    params: { isVerified },
  });
};

export default deleteActivityItemsService;
